import { FlaskConical } from "lucide-react";
import {
  DEMO_DISCLOSURE_DETAIL,
  DEMO_DISCLOSURE_TITLE,
} from "../api/curriculum-publication";

export function DemoBanner() {
  return (
    <div className="demo-banner" role="note" aria-label="界面演示说明">
      <FlaskConical aria-hidden="true" />
      <strong>{DEMO_DISCLOSURE_TITLE}</strong>
      <span>{DEMO_DISCLOSURE_DETAIL}</span>
    </div>
  );
}
